import { Input, Col } from 'design-react-kit/dist/design-react-kit';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  emaillabel: {
    id: 'Indirizzo email a cui inviare i dati *',
    defaultMessage: 'Indirizzo email a cui inviare i dati *',
  },
  invalidEmail: {
    id: '* Indirizzo email non valido',
    defaulMessage: '* Indirizzo email non valido',
  },
  requiredField: {
    id: '* Campo obbligatorio',
    defaultMessage: '* Campo obbligatorio',
  },
});

const EmailField = ({ formData, setFormData, error, setError }) => {
  const intl = useIntl();

  /**
   * Email validator
   */
  const emailValidator = e => {
    const { name, value } = e.target;
    if (name) {
      setFormData(formData => ({
        ...formData,
        email: value,
      }));
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) {
        setError(intl.formatMessage(messages.requiredField));
      } else if (!emailRegex.test(value)) {
        setError(intl.formatMessage(messages.invalidEmail));
      } else {
        setError('');
      }
    }
  };

  return (
    <Col md={6}>
      <Input
        type="email"
        id="email"
        name="email"
        label={intl.formatMessage(messages.emaillabel)}
        value={formData.email || ''}
        onChange={emailValidator}
        required
        className="mt-1 mb-0"
      />
      {error && (
        <label color="danger" htmlFor="email" className="mt-1 mb-3 text-danger">
          <small>{error}</small>
        </label>
      )}
    </Col>
  );
};

export default EmailField;
